// extracted by mini-css-extract-plugin
module.exports = {"container":"_2DtGSp","contentWrapper":"_3ta9I-","content":"_2PYzlg"};